$(document).ready(function(){
    // get/set current date
    const now = new Date()
    // set auto delay to 45 sec
    $('.toast').toast({delay: 45000});
    // check applied status
    const storageItem = JSON.parse(localStorage.getItem('pixelparker_info_toasts_applied'))
    if (storageItem === null || storageItem.value !== true || storageItem.value === true && now.getTime() > storageItem.expiry) {
        // show toasts
        $('.toast').toast('show')
    } else {
        //$('.toast').toast('hide')
        //$('.toast').toast('dispose')
        $('.toast').addClass('hide')
    }
    // create local storage item with expired date
    const item = {
        value: true,
        expiry: now.getTime() + 600000
    }
    // set applied after hide button
    $('.toast').on('hidden.bs.toast', function () {
        localStorage.setItem('pixelparker_info_toasts_applied', JSON.stringify(item))
    })
    // set applied always on first time
    // localStorage.setItem('pixelparker_info_toasts_applied', JSON.stringify(item)) - removed because not working with cookie refresh
});

